import { IExtraCartItem } from './interfaces';
import { priceExtraForRoom } from './extra-room-price';

/**
 * The extras of one room in the reservation request, and the room's deposit with them.
 *
 * Each extra is sent with the unit price and signature it was offered with for this room (a ticket with its one
 * price for all rooms). The backend calculates the total as quantity × unit price, so a prepaid deposit adds each
 * extra the same way, in cents to avoid floating point errors.
 */
export function createReservationExtras(
  cartExtras: IExtraCartItem[],
  roomIndex: number,
  isPrepaid: boolean,
  depositValue: number | string
): { extras: any[], depositValue: number | string } {
  let deposit = depositValue;

  const extras = cartExtras.map((e: IExtraCartItem) => {
    //if extra has externalId,(is external ticket), use that as rateId in booking.
    const rateId = e.externalId ? e.rateId.split("|")[0] : e.rateId.toString();

    const pricedExtra = priceExtraForRoom(e, roomIndex);
    const unitPrice = pricedExtra.unitPriceForStayWithTaxes ?? pricedExtra.totalPriceForStayWithTaxes;

    if (isPrepaid) {
      const depositInCents = Math.round(Number(deposit) * 100);
      const extrasInCents = e.quantity * Math.round(unitPrice * 100);
      deposit = parseFloat(((depositInCents + extrasInCents) / 100).toFixed(2));
    }

    return {
      "rateId": rateId,
      "extraName": e.extraName,
      "quantity": e.quantity,
      "postingRhythm": e.postingRhythm,
      "calculationRule": e.calculationRule,
      "totalPriceForStayWithTaxes": (unitPrice * e.quantity).toFixed(2),
      "unitPriceForStayWithTaxes": unitPrice,
      "signature": pricedExtra.signature ?? null,
      "isTicket": !!e.externalId,
      "externalId": e.externalId ?? null
    };
  });

  return { extras, depositValue: deposit };
}
